"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const TableRow_1 = __importDefault(require("@Components/ViewWork/Table/TableRow"));
const clsx_1 = __importDefault(require("clsx"));
const SubTable_1 = __importDefault(require("@Components/ViewWork/Table/SubTable"));
const ExpandableTableRow = ({ className, tableRow, removableCells, onRemoveCellClicked }) => {
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(true);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableRow_1.default, { className: (0, clsx_1.default)(className, tableRow.subTables && 'parent-table', isExpanded && 'expanded-row'), tableRow: tableRow, removableCells: removableCells, defaultExpanded: isExpanded, onRemoveCellClicked: onRemoveCellClicked && onRemoveCellClicked, onExpandCellClicked: (expanded) => setIsExpanded(expanded) }),
        tableRow.subTables && isExpanded && (react_1.default.createElement("div", { className: 'nested-table table-cell' }, tableRow.subTables.map((subTable, subTableIdx) => (react_1.default.createElement(SubTable_1.default, Object.assign({}, subTable, { key: `sub-row-table-${subTableIdx}` }))))))));
};
exports.default = ExpandableTableRow;
